import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  saveLeadSource,
  listenLeadSources,
  deleteLeadSource,
  updateLeadSource,
} from "../../utils/firebasefunctions";
import { Trash2 } from "lucide-react";
import { MdEdit } from "react-icons/md";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";

const LeadSourcePage = () => {
  const [abbreviation, setAbbreviation] = useState("");
  const [name, setName] = useState("");

  const [leadCommission, setLeadCommission] = useState("");
  const [loading, setLoading] = useState(false);
  const [leadSources, setLeadSources] = useState([]);
  const [isAbbreviation, setIsAbbreviation] = useState(false);
  const [isName, setIsName] = useState(false);
  const [updateitem, setupdateitem] = useState("");
  const [{}, dispatch] = useStateValue();

  // ✅ Handle Save
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (abbreviation === "") {
      toast.error("Abbreviation is required");
      setIsAbbreviation(true);
      return;
    } else if (name === "") {
      toast.error("Source Name is required");
      setIsName(true);
      return;
    }

    setLoading(true);

    try {
      let result;

      if (updateitem === "") {
        result = await saveLeadSource({
          abbreviation,
          name,
          leadCommission,
        });
      } else {
        result = await updateLeadSource(updateitem.docId.toString(), {
          abbreviation,
          name,
          leadCommission,
        });
      }

      if (result.success) {
        if (updateitem) {
          toast.success("Lead Source updated successfully!");
          setupdateitem("");
        } else {
          toast.success("Lead Source saved successfully!");
        }

        // Reset form only after success
        setAbbreviation("");
        setName("");

        setLeadCommission("");
      } else {
        toast.error(result.error || "Failed to save lead source");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
    // } else {
    //   setupdateitem("");
    // }
  };

  // ✅ Handle Delete
  const handleDelete = async (id) => {
    // if (window.confirm("Are you sure you want to delete this lead source?")) {
    // setLoading(true);
    try {
      const result = await deleteLeadSource(id);
      if (result.success) {
        toast.success("Lead Source deleted successfully!");
      } else {
        toast.error(result.error || "Failed to delete lead source");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      // setLoading(false);
    }
    // }
  };

  const handleUpdate = async (item) => {
    setupdateitem(item);

    setAbbreviation(item.abbreviation);
    setName(item.name);

    setLeadCommission(item.leadCommission);
  };

  // ✅ Real-time listener for table
  useEffect(() => {
    // const unsubscribe = listenLeadSources(setLeadSources);
    const unsubscribe = listenLeadSources((data) => {
      setLeadSources(data);

      dispatch({
        type: actionType.STORE_LEADS,
        payload: data,
      });
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="">
      {/* <h1 className="text-2xl font-bold mb-4">Create Lead Source</h1> */}
      {/* <header className="flex flex-col lg:flex-row justify-between items-center text-center lg:text-left px-10 py-7 lg:py-5 border-b border-black/10 bg-white">
        <div className="page-title">
          <h2 className="text-3xl sm:text-4xl font-bold bg-[#1E293B] bg-clip-text text-transparent">
            Lead Source
          </h2>
        </div>
      </header> */}

      <form onSubmit={handleSubmit}>
        <div className="flex flex-col lg:flex-row lg:justify-between gap-4">
          <div className="w-full lg:w-[49%]">
            <label className="block font-medium">
              Lead Source Abbreviation *
            </label>
            <input
              type="text"
              value={abbreviation}
              placeholder="Enter Lead Source Abbreviation"
              onChange={(e) => setAbbreviation(e.target.value)}
              className={`w-full mt-1 ${
                isAbbreviation ? "border-2 border-red-600" : ""
              } text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
            />
          </div>
          <div className="w-full lg:w-[49%] mt-5 lg:mt-0">
            <label className="block font-medium">Lead Source Name *</label>
            <input
              type="text"
              value={name}
              placeholder="Enter Lead Source Name"
              onChange={(e) => setName(e.target.value)}
              className={`w-full mt-1 ${
                isName ? "border-2 border-red-600" : ""
              } text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:justify-between mt-5">
          <div className="w-full lg:w-[49%] mt-5 lg:mt-0">
            <label className="block font-medium">
              Lead Commission (Optional)
            </label>
            <input
              type="number"
              placeholder="Enter Lead Commission"
              value={leadCommission}
              onChange={(e) => setLeadCommission(e.target.value)}
              className="text-sm w-full mt-1 rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50"
            />
          </div>
        </div>
        <div className="flex justify-center mt-6">
          <button
            type="submit"
            className="text-base font-medium bg-themeColor shadow-md hover:bg-themeColor/90  mt-3 flex justify-center items-center text-white rounded-full py-[10px] px-20"
          >
            <span>{updateitem != "" ? "Update" : "Submit"}</span>
            {loading && (
              <div role="status" className="pl-3">
                <svg
                  aria-hidden="true"
                  class="w-6 h-6 text-gray-200 animate-spin dark:text-white fill-themeColor"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            )}
          </button>
        </div>
      </form>
      <div className="overflow-x-auto panelScroll mt-6 bg-white rounded-2xl border border-gray-200 shadow-sm">
        <h2 className="text-xl font-semibold mb-2 p-6">
          Lead Sources
        </h2>
        <table className="min-w-[700px] w-full">
          <thead>
            <tr className="bg-gray-50">
              <th className=" px-4 py-3 whitespace-nowrap !font-semibold text-center uppercase text-xs tracking-wider text-gray-500">
                Abbreviation
              </th>
              <th className="px-4 py-3 whitespace-nowrap !font-semibold text-center uppercase text-xs tracking-wider text-gray-500">
                Source Name
              </th>

              <th className="px-4 py-3 whitespace-nowrap !font-semibold text-center uppercase text-xs tracking-wider text-gray-500">
                Lead Commission
              </th>
              <th className="px-4 py-3 whitespace-nowrap !font-semibold text-center uppercase text-xs tracking-wider text-gray-500">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {leadSources.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  className="text-center font-semibold text-md py-10 text-gray-500"
                >
                  No lead sources added yet
                </td>
              </tr>
            ) : (
              leadSources.map((source, i) => (
                <tr
                  key={i}
                  className="border-b border-gray-200 hover:bg-gray-50 transition-colors duration-200"
                >
                  <td className="px-4 py-3 font-normal text-center">
                    {source.abbreviation}
                  </td>
                  <td className="px-4 py-3 text-center ">
                    {source.name}
                  </td>

                  <td className="px-4 py-3  font-normal text-center">
                    {source.leadCommission ? source.leadCommission + "%" : "-"}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <button
                      onClick={() => handleUpdate(source)}
                      className=" mr-[5px]"
                      title="Update Lead Source"
                    >
                      <MdEdit
                        size={18}
                        className="text-linkColor hover:text-themeColor"
                      />
                    </button>
                    <button
                      onClick={() => handleDelete(source.id)}
                      className="text-red-500 hover:text-red-700"
                      title="Delete Lead Source"
                    >
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeadSourcePage;
